import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import './ReferralDropdownButtons.scss';
import { ReferralShareModal } from '../ReferralModals/ReferralShareModal';

interface IReferralDropdownButtons {
    referralId?: number;
    canShare: boolean;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
}

export const ReferralDropdownButtons: React.FunctionComponent<IReferralDropdownButtons> = ({ referralId, canShare, changeSuccessMessage, changeErrorMessage, getReferral }) => {

    const [renderShareModal, setRenderShareModal] = React.useState<boolean>(false);
    
    return (
        <>
            {
                canShare ?
                    <>
                        <div className="referral-dropdown-buttons" >
                            <div className="btn-group">
                                <button type="button" id="referralDropdownButtons" className="btn btn-sm btn-warning" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={!(canShare)}>
                                    Administrera <FontAwesomeIcon tabIndex={-1} icon={faCaretDown} size="lg" />
                                </button>

                                <div className="dropdown-menu" aria-labelledby="referralDropdownButtons">
                                    {
                                        canShare ?
                                            <>
                                                <a className="dropdown-item" data-toggle="modal" data-target="#share-referral-modal" href="#" onClick={() => setRenderShareModal(true)}>Dela remiss</a>
                                            </>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            canShare ?
                                <ReferralShareModal referralId={referralId ?? 0} renderForm={renderShareModal} onFormClose={() => setRenderShareModal(false)} changeSuccessMessage={changeSuccessMessage} getReferral={getReferral} />
                                : null
                        }
                    </>
                    : null
            }
        </>
    )
}